import Vue from 'vue';
let Dialog = Vue.extend(require('./index.vue').default);
import {store} from '../main'





Vue.prototype.$modal = function (type, param) {
    let instance = new Dialog({
        data: {
            type: type,
            param: param,
            visible: false,
            title: '',
        },
        store,
    });
    setTimeout(()=>{
        instance.visible= true;
    });
    instance.close = function () {
        if(typeof param.close === 'function'){
            param.close();
        }
        instance.visible = false;
        setTimeout(()=>{
            instance.$destroy();
        },300)
    };
    instance.change = function (val) {
        if(typeof param.change === 'function'){
            param.change(val);
        }
        instance.visible = false;
        setTimeout(()=>{
            instance.$destroy();
        },300)
    };
    instance.destroyed = ()=>{
        setTimeout(()=>{
            document.body.removeChild(instance.$el);
        },300)

    };
    document.body.appendChild(instance.$mount().$el);

    return instance;
};
